import { render, staticRenderFns } from "./manualshs.vue?vue&type=template&id=b2bc5fa0&scoped=true&"
import script from "./manualshs.vue?vue&type=script&lang=js&"
export * from "./manualshs.vue?vue&type=script&lang=js&"
import style0 from "./manualshs.vue?vue&type=style&index=0&id=b2bc5fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bc5fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2bc5fa0')) {
      api.createRecord('b2bc5fa0', component.options)
    } else {
      api.reload('b2bc5fa0', component.options)
    }
    module.hot.accept("./manualshs.vue?vue&type=template&id=b2bc5fa0&scoped=true&", function () {
      api.rerender('b2bc5fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manualshs.vue"
export default component.exports